// API client for Mindstream backend

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export const api = {
  baseUrl: API_BASE_URL,

  async submitWaitlist(
    email: string,
    source: string
  ): Promise<{ success: boolean; message: string }> {
    const res = await fetch(`${API_BASE_URL}/api/waitlist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, source }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      const error = new Error(body?.detail?.error?.message || 'Failed to join waitlist');
      (error as any).status = res.status;
      (error as any).code = body?.detail?.error?.code || 'unknown';
      throw error;
    }
    return res.json();
  },

  // Beta invite code validation
  async validateInviteCode(code: string): Promise<{
    success: boolean;
    email: string;
    plan_type: 'paid_beta' | 'free_beta';
    entitlement_days: number;
  }> {
    const res = await fetch(`${API_BASE_URL}/api/beta/validate-code`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      const errorCode = body?.detail?.error?.code || 'unknown';
      const error = new Error(body?.detail?.error?.message || 'Validation failed');
      (error as any).status = res.status;
      (error as any).code = errorCode;
      throw error;
    }
    return res.json();
  },

  async redeemFreeBeta(code: string): Promise<{
    success: boolean;
    already_redeemed: boolean;
    source: 'free_beta';
  }> {
    const res = await fetch(`${API_BASE_URL}/api/beta/redeem-free-beta`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      const error = new Error(body?.detail?.error?.message || 'Activation failed');
      (error as any).status = res.status;
      (error as any).code = body?.detail?.error?.code || 'unknown';
      throw error;
    }
    return res.json();
  },

  // Stripe checkout session creation
  async createCheckoutSession(code: string): Promise<{ checkout_url: string }> {
    const res = await fetch(`${API_BASE_URL}/stripe/create-checkout-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      const error = new Error(body?.detail?.error?.message || 'Payment error');
      (error as any).status = res.status;
      (error as any).code = body?.detail?.error?.code || 'unknown';
      throw error;
    }
    return res.json();
  },
};

export default api;
